import { render, staticRenderFns } from "./formattedCurrency.vue?vue&type=template&id=256c4094&"
import script from "./formattedCurrency.vue?vue&type=script&lang=js&"
export * from "./formattedCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports